import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReports1Route: InvariantJiraRoute = {
	name: 'csm-reports',
	path: '/jira/customer-service-management/projects/:projectKey/reports',
	exact: true,
};
